/**
 *  This function is used to replace text on a webpage.
 *  For use in preparing Blokur demos.
 */

import $ from 'jquery';

export default function mask(user) {
    if (!user || !user.name) {
        return;
    }
    const REPLACE_MAP = {
        [user.name]: 'Big Tuna Publishing',
        [user.name.toUpperCase()]: 'BIG TUNA PUBLISHING',
        ...(user.username && { [user.username]: 'BIGTUNA' }),
        ...(user.email && { [user.email]: 'demo@bigtuna.com' }),
    };
    const strReplaceAll = (target, search, replacement) => target.split(search).join(replacement);

    // replace text for normal nodes
    $('h1, h2, h3, h4, h5, h6, p, a').each(function () {
        let node = $(this);
        for (const key in REPLACE_MAP) {
            if (node.text().includes(key)) {
                node.text(strReplaceAll(node.text(), key, REPLACE_MAP[key]));
            }
        }
    });

    // replace just the text for nodes with both child nodes and text
    $('div, span, li').each(function () {
        const node = $(this)
            .contents()
            .filter(function () {
                return this.nodeType == 3;
            })
            .first();
        for (const key in REPLACE_MAP) {
            if (node.text().includes(key)) {
                node.replaceWith(strReplaceAll(node.text(), key, REPLACE_MAP[key]));
            }
        }
    });

    // replace display pictures with Big Tuna logo
    const bigTunaUrl = 'https://s3-eu-west-1.amazonaws.com/blokur-public/images/big-tuna.png';
    $('.bk-display-picture').each(function () {
        const $el = $(this);
        const img = $el.find('> img');
        if (img.length) {
            // User has a display picture — only replace if it matches the current user's
            if (!user.display_picture || (img.attr('src') && img.attr('src').includes(user.display_picture))) {
                img.attr('src', bigTunaUrl);
            }
        } else {
            // User has no display picture (showing acronym) — replace with Big Tuna image
            $el.find('> .acronym').replaceWith(`<img src="${bigTunaUrl}" alt="User avatar" />`);
        }
    });
}
